import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";

const titleHeader: React.FC<{ count: number }> = ({ count }) => {
  const { t } = useTranslation("shopByBrands");

  return (
    <div className="content_heading">
      <div className="container">
        <h3 className="title">
          {t("shopByBrandTitle")}{" "}
          {count > 0 && (
            <span className="title-brands-count">
              {" "}
              {count} {t("total")}
            </span>
          )}
        </h3>
      </div>
    </div>
  );
};

export default titleHeader;
